export default "__VITE_ASSET__CJ1sQSzL__"